import { RouteError } from '@/components/route-error'
import { RoutePending } from '@/components/route-pending'
import { createFileRoute,redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/catalog/products/new')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  beforeLoad: () => {
    throw redirect({ to: '/catalog/products' })
  },
  component: () => null,
})
